module.exports = __webpack_public_path__ + "static/media/acro2.19b76075.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/clinics/acro2.jpg
// module id = 260
// module chunks = 0